import { NgModule } from '@angular/core';
import { ConfirmModalTermsDirective } from './confirm-modal-terms-directive';
import { IfScreenSizeDirective } from './if-screen-size.directive';
import { ImgDefaultDirective } from './img-default-directive';
import { NgSubscribeDirective } from './ng-subscribe.directive';
import { WebsiteContentFeatureFlagDirective } from './website-content-feature-flag.directive';
import { ImgBackgroundGrabberDirective } from './img-background-grabber.directive';
import { CustomOwlCarousel } from './carousel.directive';
import { IsCheckedInDirective } from './is-checked-in.directive';
import { NotIsCheckedInDirective } from './not-is-checked-in.directive';
import { AttributeTransValueDirective } from './attribute-trans-value.directive';
import { AnimateSvgDirective } from './animate-svg.directive';
import { ImgPreloadDirective } from './img-preload.directive';
// import { BarcodeDirective } from './barcode.directive';
import { CampaignImageDirective } from './campaign-content-image.directive';

@NgModule({
  declarations: [
    IfScreenSizeDirective,
    WebsiteContentFeatureFlagDirective,
    ImgDefaultDirective,
    ConfirmModalTermsDirective,
    NgSubscribeDirective,
    ImgBackgroundGrabberDirective,
    CustomOwlCarousel,
    IsCheckedInDirective,
    NotIsCheckedInDirective,
    AnimateSvgDirective,
    ImgPreloadDirective,
    CampaignImageDirective,
    // BarcodeDirective,
  ],
  exports: [
    IfScreenSizeDirective,
    WebsiteContentFeatureFlagDirective,
    ImgDefaultDirective,
    ConfirmModalTermsDirective,
    NgSubscribeDirective,
    ImgBackgroundGrabberDirective,
    CustomOwlCarousel,
    IsCheckedInDirective,
    NotIsCheckedInDirective,
    AttributeTransValueDirective,
    AnimateSvgDirective,
    ImgPreloadDirective,
    CampaignImageDirective,
    // BarcodeDirective,
  ],
  imports: [AttributeTransValueDirective],
})
export class DirectivesModule {}
